import {
  GET_PAYMENT_METHODS,
  GET_PAYMENT_METHODS_FAILED,
  GET_PAYMENT_METHODS_SUCCEEDED,
} from 'Redux/Types/PaymentMethodTypes'

const INITIAL_STATE = {
  records: [],
  loading: false,
  recordsFetched: false,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_PAYMENT_METHODS:
      return {
        ...state,
        loading: true,
        recordsFetched: false,
      }
    case GET_PAYMENT_METHODS_FAILED:
      return {
        ...state,
        loading: false,
        recordsFetched: false,
      }
    case GET_PAYMENT_METHODS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        records: payload,
        recordsFetched: true,
      }

    default:
      return state
  }
}
